/**
 * Manual Loading Module
 * Handles loading ad slots manually
 * version 2.1.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/manualloading',[
    "jquery",
    "logging",
    "utilities",
    "AdPlatforms/dfp",
    "AdModules/headerbidding"
], function ($, logging, utilities, dfp, headerbidding) {
    "use strict";

    var _ModuleName = "Manual Ad Slot Loader";

    var _config = {};
    var _data = {
        slots: [],
        pageconfig: {}
    };

    /**
     * Get configuration data off config object
     * @param {Config} config Configuration object
     */
    var init = function (config) {
        $.extend(_config, config.manualloading);
    }

    /**
     * Starts off manual load capabilities by storing the page config
     * @param {pageconfig} pageconfig page configuration object
     */
    var start = function (pageconfig) {
        // Store page config
        _data.pageconfig = pageconfig;
    }

    /**
     * Register an ad slot for lazy loading
     * @param {AdSlot} slot Ad slot object
     */
    var registerSlot = function (slot) {
        _data.slots.push(slot);
        ;
    }

    var registerSlots = function (slots) {
        for (var i = 0; i < slots.length; i++) {
            _data.slots.push(slots[i]);
            ;
        }
    }

    var _manualcount = 0;

    var loadAdManually = function (requestId) {
        loadAdsManually([ requestId ]);
    }

    var loadAdsManually = function (requestIds) {
        // Find slots with request Ids requested, and not already loaded
        var slots = _data.slots.filter(function (s) { return requestIds.indexOf(s.id) > -1 && !s.loaded; });
        
        // If we don't have any slots to load, we're done here
        if (slots.length === 0) return;

        if (dfp.loadSlots(slots, _data.pageconfig)) {
            // Create Ready Monitor for DFP Refresh
            var readyMonitorName = 'dfpmanual' + (++_manualcount);
            utilities.registerReadyMonitor(readyMonitorName, function () {
                ;
                // Call Refresh
                dfp.refreshSlots(slots);
            });

            headerbidding.refresh(slots, readyMonitorName);
        }
    }

    /**
     * Removes slot from being tracked
     */
    var removeSlot = function (slot) {
        try {
            var index = _data.slots.findIndex(function(s) { return s.id == slot.id; });
            if(index >= 0) {
                ;
                _data.slots.splice(index, 1);
                ;
            }                
        } catch (error) {
            logging.error("Failed to remove slot", _ModuleName);
            logging.error(error, _ModuleName);
        }
    }

    return {
        init: init,
        start: start,
        registerSlot: registerSlot,
        registerSlots: registerSlots,
        loadAdManually: loadAdManually,
        loadAdsManually: loadAdsManually,
        enabled: (function () { return _config.enabled; }),
        removeSlot: removeSlot
    }
});
